export default {
  lg: 40,
  md: 32,
  sm: 24,
  unit: 4,
  xl: 60,
  xs: 16,
};
